module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_number_green_04-1b6e6cb03273f07df60f16b0c31ae433.svg";